import "./App.css";
import Game from "./components/Game";
import { GameStateProvider } from "./components/GameState";
const App = () => {
  return (
    <GameStateProvider>
      <div className="App">
        <Game />
      </div>
    </GameStateProvider>
  );
};

export default App;
